import { useState, useEffect } from 'react';
import { encode } from 'querystring';

import { handlePartialUpload } from '../../Utils/Upload.jsx';
import { API_ENDPOINTS } from '../../common.js';

/** Gestion de l'enregistrement d'une participation vidéo
 * 
 * @param {dict} participation 
 * @param {function} setSendingParticipationState 
 * @param {function} setContinueEnabled
 * @param {function} changerPage 
 * @param {function} updateParticipation
 * @returns 
 */
export function ManageAudioRecorder(
    participation,
    setSendingParticipationState,
    sendingParticipationState,
    setContinueEnabled,
    changerPage,
    updateParticipation,
) {

    const [audioURL, setAudioURL] = useState('');
    const [audioBlob, setAudioBlob] = useState();
    const sendRecordParticipation = async () => {
        if (participation.id || participation.task_id || sendingParticipationState === 'sended') {
            return;
        }
        if (!audioBlob) {
            return;
        }

        updateParticipation();

        // Check mandatory
        //let withError = await checkMandatoryFields();
        //if (withError)
        //    return;

        // Save exxtraUserInformation if asked or delete them
        // Sauvegarder les extraUserInformation si souhaitée sinon les supprimer
        //saveRemeberMe();

        setSendingParticipationState('sending');
        setContinueEnabled(false);
        const extension = 'webm';
        const file = new File([audioBlob], `recording.${extension}`, { type: `video/${extension}` });
        // Initialize upload (get url storage)
        const { data_id, url } = await fetch(API_ENDPOINTS.upload, {
            method: 'POST',
            body: JSON.stringify({ extension }),
            headers: {
                'content-type': 'application/json'
            }
        }).then(response => {
            if (response.status >= 400) {
                throw new Error("Server respond with error !");
            }
            else {
                return response.json();
            }
        });
        // Processed to upload using previous storage url
        await handlePartialUpload(file, url);
        // Gestion des données dans le cas d'un témoinage
        let content = {}
        if (participation.voteValue) {
            content = participation.voteValue;
        }
        if (participation.textAnswer) {
            content.text = participation.textAnswer;
        }
        // Create intreaction
        const query = {
            channel_id: participation.channel_id,
            segment: participation.segment,
            language: participation.language,
            device_id: participation.device_id,
            data_id,
            extension
        };
        // PUT method is for voice recording
        const data = await fetch(API_ENDPOINTS.interactions + `?${encode(query)}`,
            {
                method: "PUT",
                headers: {
                    'Content-Disposition': 'form-data; name="file"; filename="recording.webm"',
                    'Content-Type': 'audio/webm',
                    'Extra-User-Information': JSON.stringify(participation.extra_user_information),
                    'Collect-Content': JSON.stringify(content),
                }
            }).then(response => {
                if (response.status >= 400) {
                    throw new Error("Server respond with error !");
                }
                else {
                    return response.json();
                }
            });
        participation.id = data.id;
        await setSendingParticipationState('sended');
        await changerPage();
        return data;
    };



    return {
        audioBlob,
        setAudioBlob,
        sendRecordParticipation,
        audioURL,
        setAudioURL,

    }
}